export default {
  setPromotions(state: any, promotions: any) {
    state.promotions = promotions || []
  },
  setPromotion(state: any, promotion: any) {
    state.promotions = state.promotions.map((p: any) => (p.id === promotion.id ? promotion : p))
  },
  setLetters(state: any, {results, count}: any) {
    state.letters = results || []
    state.lettersCount = count || 0
  },
  setBonuses(state: any, {results, count}: any) {
    state.bonuses = results || []
    state.bonusesCount = count || 0
  },
}
